@use "../../../scss/settings/colors";
@use "../../../scss/settings/breakpoints";

.add_button {
  width: auto !important;
  height: 45px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
  gap: 8px;
  font-family: 'Medium Inter', sans-serif !important;
  font-size: 14px !important;
  text-transform: none !important;
  letter-spacing: inherit !important;
  color: colors.$base-white !important;
  background-color: colors.$brand-purple !important;
  border: 1px solid colors.$brand-purple !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  transition: background-color 0.3s, color 0.3s, border-color 0.3s !important;

  &:hover {
    color: colors.$brand-purple !important;
    background-color: colors.$base-white !important;
    border-color: colors.$brand-purple !important;
    box-shadow: none !important;
  }

  &:global(.Mui-disabled):hover, &[disabled]:hover {
    color: colors.$base-white !important;
    background-color: colors.$brand-purple !important;
    border-color: colors.$brand-purple !important;
  }

  svg {
    width: 16px;
    height: auto;
  }

}

.grid_margin_bottom {
  padding-top: 0 !important;
}

.page_title {
  color: colors.$base-black;
  font-size: 26px;
}

.form_box {
  position: absolute;
  z-index: 1005;
  left: calc(100% + 8px);
  top: 0;
  animation: pulse 0.5s ease-in-out;
  border-color: colors.$brand-purple;
}

.form_upload{
  border-color: colors.$brand-purple;
  margin-left: 2rem;

}

.card_list_view_container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 5px 8px;
  background-color: colors.$gray-variant-21;
  border-radius: 8px;
  border: 1px solid colors.$gray-variant-4;
}

.variant_btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 3px 6px;
  font-family: 'Medium Inter', sans-serif;
  font-size: 12px;
  text-transform: none;
  color: colors.$dark-blue;
  background-color: transparent;
  border-color: transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s;

  &[disabled]{
    opacity: 0.5;
  }

  &.variant_btn_active, &:hover {

    &:not([disabled]) {
      color: colors.$base-white;
      background-color: colors.$purple-light-5;
    }

  }

  svg {
    width: 16px;
    height: 16px;
    fill: currentColor !important;
  }

}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  //margin-top: 16px !important;
  color: colors.$gray-variant-16;

  .documentViewText {
    text-decoration-color: colors.$brand-purple;
    text-decoration-thickness: 1.5px;
    text-underline-offset: 6px;
    font-size: 14px;
  }

  h3.documentViewText {
    font-size: 15px;
    line-height: 24px;
    cursor: pointer;
  }

  a, h3 {
    text-decoration: underline;
    color: colors.$brand-purple;

    &:hover {
      text-decoration: none;
    }

  }

}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

// ---------- Responsive ----------
.form_box {

  @media #{breakpoints.$mobile}{
    position: fixed;
    top: 50%;
    left: 16px;
    right: 16px;
    margin-left: 0;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    transform: translateY(-50%);
    animation: none;
    z-index: 1300;
  }

}

.form_upload {

  @media #{breakpoints.$mobile}{
    margin-left: 0;
  }

}
